export const externalRedirectRoutes: Record<"crmId", string> = {
  crmId: "external-redirects/crm/:crmId"
};
